export default class BannerInfo{

    constructor(element) {
        this.$wrapper = element;
        this.$close = this.$wrapper.querySelector('.js-banner-info-close');

        this.bindEvents();
    }

    bindEvents(){
        this.$close.addEventListener('click', () => {
           this.$wrapper.classList.add('is-hidden');
           this.setCookie('banner_hidden',true,30)
        });
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
}